export const cf7 = () => {
  const pageContact = document.querySelector(".js-page-contact");
  if (!pageContact) return;

  const category = document.querySelector("#category");
  const categoryLabel = document.querySelector("#category-label");

  if (!category || !categoryLabel) return;

  const syncCategoryLabel = () => {
    const option = category.options[category.selectedIndex];
    categoryLabel.value = option ? option.text : "";
  };

  syncCategoryLabel();
  category.addEventListener("change", syncCategoryLabel);
};
